const AbstractVerifoneRequestRecord = require('./AbstractVerifoneRequestRecord');
const VerifoneActionNames = require('../../Constants/VerifoneActionNames');

class VerifoneContinueTransactionRecord extends AbstractVerifoneRequestRecord {
    /**
     * @param {string} actionName
     * @param {number} actionID
     * @param {string} message
     */
    constructor(actionName, actionID, message) {
        super();

        /**
         * The name/key of this action. For our own use, this is not sent to the terminal.
         *
         * @see {VerifoneActionNames}
         *
         * @type {string}
         */
        this.actionName = actionName;

        /**
         * This is the required action to perform. These are defined below within a separate table.
         *
         * @type {number}
         */
        this.actionId = actionID;

        /**
         * This field will contain any information that the POS may require that is associated with that status.
         * The following parameters are available:
         * REPRINTOPT=FILE Reprint to file rather than current printer
         * AUTHCODE= The auth code to be supplied to PAYware Ocius for VR transactions / Charge Only transactions
         * CASHBACK= The cashback to be added to the transaction
         * MGRPIN= The manager PIN to use
         * PAYPOINTACCID= The PayPoint account ID to use
         * PAYPOINTOPTIONID= The PayPoint Scheme Option to use
         */
        this.parameters = {};

        /**
         * Used internally as a description of this action to show to the user.
         *
         * @type {string}
         */
        this.description = message;
    }

    /**
     * @return {[]}
     */
    toArray() {
        // Convert the parameters to the required format:
        // "<Name>=<Value>;<Name>=<Value>"
        let parametersStr = '';
        Object.keys(this.parameters).forEach((name) => {
            if (parametersStr.length > 0) {
                parametersStr += ';';
            }
            parametersStr += name + '=' + this.parameters[name];
        });

        let params = [
            'CONTTXN', // 1: Message Type
            this.actionId, // 2: Action ID
        ];

        // The docs for Engage now say "The third field is conditional and should only be present if there is data
        // to populate it with". It breaks if you have a trailing comma so remove it.
        // This has been tested with POS Client and does not break BC.
        if (parametersStr) {
            params.push(parametersStr); // 3: Parameters
        }

        return params;
    }

    /**
     * @return {string}
     */
    getButtonClass() {
        const successActions = [
            VerifoneActionNames.CONTINUE_TRANSACTION,
            VerifoneActionNames.CONFIRM_SIGNATURE,
            VerifoneActionNames.CONFIRM_AUTH_CODE,
        ];
        if (successActions.indexOf(this.actionName) !== -1) {
            return 'btn-success';
        }

        const dangerActions = [
            VerifoneActionNames.CANCEL_TRANSACTION,
            VerifoneActionNames.REJECT_SIGNATURE,
            VerifoneActionNames.REJECT_AUTH_CODE,
        ];
        if (dangerActions.indexOf(this.actionName) !== -1) {
            return 'btn-danger';
        }

        return 'btn-info';
    }
}

module.exports = VerifoneContinueTransactionRecord;
